import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';

import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import DATA_MINING_CONTROLLER from '../../../controllers/dataMining';
import ReactComponentHelper from '../../helper/ReactComponentHelper';
import { TableConfig } from '../../../utils/appConfig';
import NoData from '../../page/NoData';
import Pagination from '../../page/Pagination'
import SiiTransactionsColumnDefinition from '../reportDefinition/SIITransactions';

import Logger, { LOG_LEVELS, ALL_MESSAGES } from '../../../utils/logger';
import ApplicationMessages from '../../inAppMessages/ApplicationMessages';
const log = new Logger('DATA_MINING_SII_TRANSACTIONS_PAGE', LOG_LEVELS.DEBUG);

const siiTransactionsColumnMapping = {
  "nr": "Nr",
  "id": "Id",
  "company": "Company",
  "documentID": "DocumentID",
  "documentNumber": "DocumentNumber",
  "invoiceNumber": "Invoice Number",
  "supplierInvoiceNumber": "Supplier Invoice Number",
  "sapReferenceDocument": "SAP Reference Document",
  "invoiceDate": "InvoiceDate",
  "event": "Event",
  "eventCreated": "EventCreated",
  "procStatus": "Proc_Status",
  "procStatusUpdated": "Proc_StatusUpdated",
  "errorCode": "ErrorCode",
  "errorDescription":"ErrorDescription",
  "reportingDate":"ReportingDate",
  "reporterNif": "Reporter_Nif",
  "partnerNif": "Partner_Nif",
  "partnerName": "Partner_Name",
  "partnerOtherIDCountry": "Partner_OtherID_Country",
  "partnerOtherIDType": "Partner_OtherID_Type",
  "partnerOtherIDID": "Partner_OtherID_ID",
  "uuid": "UUID",
  "csv": "CSV",
  "realTimeInvoiceKey": "RealTimeInvoiceKey",
  "invoicePropertiesInvoiceKey": "invoicePropertiesInvoiceKey",
  "refDocID": "Ref_DocID"
};

const DEFAULT_PAGINATION_CONFIG = {
    pageNumber: 1,
    pageSize: TableConfig.STANDARD_LEVEL_ONE_PAGE_SIZE,
    page:0,
    startAt: 1
};

export class siiTransactionsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: 'SII transactions'
            },
            filterCriteria: props.filterCriteria,
            pagination: DEFAULT_PAGINATION_CONFIG,
            loading: true
        };
        this.onFetchDataHandler = this.onFetchDataHandler.bind(this);
    }

    getParameters(selection, pagination) {
        let params = {
            startAt: pagination.startAt,
            pageSize: pagination.pageSize,
            startDate: selection.startDate,
            endDate: selection.endDate,
            sortAscending: selection.sortAscending,
        };
        return params;
    }

    getColumns() {
        let columnData = SiiTransactionsColumnDefinition;

        log.debug('render(): columnData', columnData);

        const columns = columnData.map((item, id) => {
            log.debug('render(): item', item, item.Accessor, item.Header);
            return {
                id: item.Accessor,
                Header: props => <LanguageStringResolver string={item.Header} />,
                accessor: item.Accessor,
                style: item.textAlign !== undefined ? { textAlign: "right" } : "",
                minWidth: item.MinWidth !== undefined ? item.MinWidth: 80,
            }
        });
        log.debug('render(): ', columns);
        return columns;
    }

    onFetchDataHandler(state) {
        log.debug('onFetchDataHandler(): ');
        let { page, pageSize } = state;
        pageSize = Object.is(pageSize, NaN) ? TableConfig.STANDARD_LEVEL_ONE_PAGE_SIZE : pageSize;
        page = Object.is(page, NaN) ? 0 : page;
        const startAt = page * pageSize;
        let pagination = Object.assign({}, this.state.pagination, {
            pageNumber: page + 1,            
            page: page,
            pageSize: pageSize,
            startAt: startAt + 1
        });

         //To set default/hidden properties of react table
         if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page = 0;
        }
        this.setState({
            pagination: pagination,
            viewTableState: state,
            loading: true
        });

         // Get url values
        this.props.getSIITransactions(this.getParameters(this.props.filterCriteria, pagination), () => {
            let pagination = Object.assign({}, this.state.pagination);
            let transactions = (this.props.siiTransactions && this.props.siiTransactions.siiInvoices) || [];
            let totalCount = (this.props.siiTransactions && this.props.siiTransactions.totalCount) || transactions.length;
            pagination.pages = pagination.pageSize === 0 ? totalCount : Math.ceil(totalCount / pagination.pageSize);
            this.setState({
                loading: false,
                pagination: pagination
            });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //when reportType is same and filters are updated/changed and clicked apply, need to call fetch data explicitely
        if ((nextProps.filterCriteria.startDate !== this.props.filterCriteria.startDate) ||
          (nextProps.filterCriteria.reportType !== this.props.filterCriteria.reportType) ||
          (nextProps.filterCriteria.endDate !== this.props.filterCriteria.endDate) ||
          (nextProps.filterCriteria.sortAscending !== this.props.filterCriteria.sortAscending))
        {
            this.props = nextProps;
            this.onFetchDataHandler(Object.assign({}, DEFAULT_PAGINATION_CONFIG, {pageSize: this.state.pagination.pageSize}));
        }
    }
    componentWillUnmount() {
        log.debug('componentWillUnmount()');
        log.clearDictionaryError(ALL_MESSAGES.REPORT_PAGE_SIZE_LOAD);
        this.props.doUnload();
    }
    render() {
        log.debug('render() - props: ', this.props);
        log.setDictionaryMessage(ALL_MESSAGES.REPORT_PAGE_SIZE_LOAD);
        let pagination = this.state.pagination || {};
        if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page =pagination.page;
        }
        const columns = this.getColumns();
        let siiTransactions = (this.props.siiTransactions && this.props.siiTransactions.siiInvoices) || [];
        let fileName = (this.state.selection && this.state.selection.reportType) ? this.state.selection.reportType.replace(' ', '') + '.csv' : "DataMining.csv";
        let siiTransactionsCsvData = siiTransactions;
        for (let key in siiTransactionsColumnMapping) {
            siiTransactionsCsvData = JSON.parse(JSON.stringify(siiTransactionsCsvData).split('"' + key + '":').join('"' + siiTransactionsColumnMapping[key] + '":'));
        }
        let columnData = SiiTransactionsColumnDefinition;

        let dateCols = columnData.filter((column) => column.IsDate).map(column => column.Accessor);
        let currencyCols = columnData.filter((column) => column.IsCurrency).map(column => column.Accessor);
        let dateAndCurrencyFormatedSiiTransactions = siiTransactions.map(dataRow => {
            dateCols.forEach((accessor) => {
                dataRow[accessor] = dataRow[accessor] ? `${dataRow[accessor]}`.substr(0, 10) : dataRow[accessor];
                const formattedDate = (dataRow[accessor] === "1899-12-30" ? "" : dataRow[accessor])
                dataRow[accessor] = formattedDate
            });
            currencyCols.forEach((accessor) => {
                dataRow[accessor] = dataRow[accessor] ? ReactComponentHelper.formatToCurrency(dataRow[accessor]) : dataRow[accessor];
            });
            return dataRow;
        });


        const NoDataComponent = props => (
            <NoData
                noDataText="transactionReports_NoData"
                {...props}
            />
        );

        return (
            <div>

                <ReactTable
                    manual
                    pages={pagination.pages || 1}
                    defaultPageSize={TableConfig.PAGINATION.REPORT_LEVEL_ONE_PAGE_SIZE}
                    pageSizeOptions={TableConfig.PAGINATION.REPORT_PAGE_SIZE_OPTIONS}
                    ref={ref => this.viewTable = ref}
                    minRows={0}
                    maxRows={0}
                    data={dateAndCurrencyFormatedSiiTransactions}
                    columns={columns}
                    loading={this.props.loading} // Display the loading overlay when we need it
                    onFetchData={this.onFetchDataHandler} // Request new data when things change
                    sortable={false}
                    showPageJump={true}
                    NoDataComponent={NoDataComponent}
                    className={_.isEmpty(siiTransactions) ? 'mb30 hide-header' : 'mb30'}
                    PaginationComponent={Pagination}
                    showPagination={siiTransactions.length === 0 ? false : true}
                />
                <span className="mt10">
                      <ApplicationMessages
                          messageIds={[ALL_MESSAGES.REPORT_PAGE_SIZE_LOAD]}
                          messageType="applicationWarning"
                      />
                </span>
                <CSVLink
                    data={sanitizeCsvData(siiTransactionsCsvData)}
                    filename={fileName}
                    className={siiTransactionsCsvData && siiTransactionsCsvData.length > 0 ? "button secondary" : "invisible"}>
                    <LanguageStringResolver string='dataMining_ExportToExcel' />
                </CSVLink>
            </div>
        );
    }
}


siiTransactionsPage.defaultProps = {
    filterCriteria: {},
    isReportTypeChanged: false
};

function mapStateToProps(state) {
    return {
        languages: state.languages,
        siiTransactions: (state.dataMining && state.dataMining.siiTransactions)
    }
}

function mapDispatchersToProps(dispatch) {
    return {
        getSIITransactions: (filterParams, callback) => {
            log.debug('getSIITransactions: ', filterParams);
            dispatch(DATA_MINING_CONTROLLER.getSIITransactions(filterParams, callback))
        },
        doUnload: (filterParams, callback) => {
            log.debug('getSIITransactions: ', filterParams);
            dispatch(DATA_MINING_CONTROLLER.doUnloadSIITransactions())
        },
    }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(siiTransactionsPage);